export default __webpack_public_path__ + "static/media/ML.382e166e.svg";